/* ==============================================================
   THIS FILE GOES IN:  Assets  >  pure-leaf.js   (the scripts — starts with document.addEventListener)
   ============================================================== */
document.addEventListener('DOMContentLoaded', function () {
  // Scroll reveals
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  // Sticky buy bar
  var bar = document.querySelector('.sticky-bar');
  if (bar) {
    window.addEventListener('scroll', function () {
      bar.classList.toggle('visible', window.scrollY > 650);
    }, { passive: true });
  }

  // Mobile menu
  var menuBtn = document.querySelector('.nav-menu-btn');
  var mobileMenu = document.querySelector('.mobile-menu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function () { mobileMenu.classList.toggle('open'); });
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
    });
  }

  // Before/After slider — swipe left to right and the marks fade
  var slider = document.querySelector('.ba-slider');
  if (slider) {
    var layer = slider.querySelector('.ba-after');
    var handle = slider.querySelector('.ba-handle');
    var dragging = false;
    var setPos = function (clientX) {
      var r = slider.getBoundingClientRect();
      var p = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
      layer.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
      handle.style.left = p + '%';
      slider.setAttribute('aria-valuenow', Math.round(p));
    };
    slider.addEventListener('pointerdown', function (e) {
      dragging = true; slider.setPointerCapture(e.pointerId); setPos(e.clientX);
    });
    slider.addEventListener('pointermove', function (e) { if (dragging) setPos(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      slider.addEventListener(ev, function () { dragging = false; });
    });
    // gentle hint sweep when it first appears
    new IntersectionObserver(function (entries, obs) {
      if (entries[0].isIntersecting) {
        obs.disconnect();
        var start = null;
        var animate = function (t) {
          if (!start) start = t;
          var k = Math.min(1, (t - start) / 2200);
          var p = 8 + Math.sin(k * Math.PI) * 37; // 8 -> 45 -> 8
          layer.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
          handle.style.left = p + '%';
          if (k < 1) requestAnimationFrame(animate);
        };
        requestAnimationFrame(animate);
      }
    }, { threshold: 0.4 }).observe(slider);
  }

  // Hero photo rotator (arrows, dots, touch swipe)
  var rot = document.getElementById('heroRotator');
  if (rot) {
    var photos = rot.querySelectorAll('.hero-photo');
    var dotsWrap = rot.querySelector('.hr-dots');
    var idx = 0;
    function show(n) {
      idx = (n + photos.length) % photos.length;
      photos.forEach(function (p, i) { p.classList.toggle('active', i === idx); });
      dotsWrap.querySelectorAll('.hr-dot').forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }
    photos.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'hr-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Show photo ' + (i + 1));
      d.addEventListener('click', function () { show(i); });
      dotsWrap.appendChild(d);
    });
    rot.querySelectorAll('.hr-btn').forEach(function (b) {
      b.addEventListener('click', function () { show(idx + parseInt(b.dataset.dir, 10)); });
    });
    var sx = null;
    rot.addEventListener('pointerdown', function (e) { sx = e.clientX; });
    rot.addEventListener('pointerup', function (e) {
      if (sx == null) return;
      var dx = e.clientX - sx; sx = null;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    });
  }

// Ingredient tabs
  var tabs = document.querySelectorAll('.ing-tab');
  var panels = document.querySelectorAll('.ing-panel');
  tabs.forEach(function (tab) {
    var activate = function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      tab.classList.add('active');
      var panel = document.querySelector('.ing-panel[data-panel="' + tab.dataset.tab + '"]');
      if (panel) panel.classList.add('active');
    };
    tab.addEventListener('mouseenter', activate);
    tab.addEventListener('click', activate);
  });
// Add to cart (bundle buttons + sticky bar)
// ==========================================================
// CART DRAWER + ADD TO CART
// ==========================================================

var cartDrawer = document.querySelector('.pl-cart-drawer');
var cartOverlay = document.querySelector('.pl-cart-overlay');
var cartClose = document.querySelector('.pl-cart-close');
var cartBag = document.querySelector('.pl-cart-bag');
var cartItems = document.querySelector('.pl-cart-items');
var cartEmpty = document.querySelector('.pl-cart-empty');
var cartCount = document.querySelector('.pl-cart-count');
var cartTotal = document.querySelector('.pl-cart-total');
var cartCompare = document.querySelector('.pl-cart-compare');
var checkoutTotal = document.querySelector('.pl-checkout-total');
var checkoutButton = document.querySelector('.pl-checkout-btn');
var shippingText = document.querySelector('.pl-shipping-text');
var shippingProgress = document.querySelector('.pl-shipping-progress');
var continueShopping = document.querySelector('.pl-cart-continue');
var savingsCard = document.querySelector('.pl-savings-card');
var upsellBox = document.querySelector('[data-upsell]');

var PRODUCT_VARIANT_ID = 48360447508710;
var FREE_SHIPPING_ATTR = cartDrawer ? cartDrawer.dataset.freeShipping : '';
/* "0" means free shipping on every order */
var FREE_SHIPPING_ALL = FREE_SHIPPING_ATTR === '0';
var FREE_SHIPPING_THRESHOLD = Number(FREE_SHIPPING_ATTR) || 6500;

/* Bundle tiers — only used for the "add another jar" suggestion text.
   The real prices always come from Shopify's cart. */
var TIER_TOTALS = {
  1: Number(cartDrawer && cartDrawer.dataset.tier1) || 4900,
  2: Number(cartDrawer && cartDrawer.dataset.tier2) || 8400,
  3: Number(cartDrawer && cartDrawer.dataset.tier3) || 10900
};
var SUPPLY_LABELS = { 1: '1-month supply', 2: '2-month supply', 3: '3-month supply' };

function money(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function moneyShort(cents) {
  return cents % 100 === 0 ? '$' + (cents / 100) : money(cents);
}

function escapeHtml(value) {
  var div = document.createElement('div');
  div.textContent = value || '';
  return div.innerHTML;
}

function openCartDrawer() {
  if (!cartDrawer || !cartOverlay) return;
  cartDrawer.classList.add('open');
  cartOverlay.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  cartOverlay.setAttribute('aria-hidden', 'false');
  document.body.classList.add('pl-cart-open');
}

function closeCartDrawer() {
  if (!cartDrawer || !cartOverlay) return;
  cartDrawer.classList.remove('open');
  cartOverlay.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartOverlay.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('pl-cart-open');
}

async function getCart() {
  var response = await fetch('/cart.js', {
    headers: { 'Accept': 'application/json' }
  });
  if (!response.ok) {
    throw new Error('Unable to load cart.');
  }
  return response.json();
}

function renderCart(cart) {
  if (!cartItems) return;

  cartItems.innerHTML = '';

  if (cartCount) {
    cartCount.textContent = cart.item_count;
    cartCount.dataset.count = cart.item_count;
  }

  var hasItems = cart.items.length > 0;
  if (cartEmpty) cartEmpty.hidden = hasItems;

  var creamLine = null;
  var creamIndex = -1;
  var totalSavings = 0;
  var inCart = {};

  var protectToggle = document.querySelector('.pl-protect-toggle');
  var PROTECT_ID = protectToggle ? Number(protectToggle.dataset.protectVariant) : 0;
  var shippable = 0;

  cart.items.forEach(function (item, index) {
    inCart[item.variant_id] = true;
    if (item.variant_id === PROTECT_ID) return;   /* shown as the switch at the bottom instead */
    shippable += item.quantity;

    var isCream = item.variant_id === PRODUCT_VARIANT_ID;
    var savings = Math.max(0, item.original_line_price - item.final_line_price);
    totalSavings += savings;

    if (isCream) {
      creamLine = item;
      creamIndex = index;
    }

    var meta = '';
    if (isCream) {
      var supply = SUPPLY_LABELS[item.quantity] || (item.quantity + ' jars');
      meta = supply + ' · ' + money(Math.round(item.final_line_price / item.quantity)) + ' / jar';
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      meta = escapeHtml(item.variant_title);
    }

    var pct = savings > 0
      ? Math.round((savings / item.original_line_price) * 100)
      : 0;

    var image =
      item.image ||
      (item.featured_image && item.featured_image.url) ||
      '';

    var itemEl = document.createElement('div');
    itemEl.className = 'pl-cart-item';

    itemEl.innerHTML =
      '<div>' +
        (image
          ? '<img class="pl-cart-item-image" src="' + escapeHtml(image) +
            '" alt="' + escapeHtml(item.product_title) + '">'
          : '') +
      '</div>' +
      '<div>' +
        '<div class="pl-cart-item-title">' + escapeHtml(item.product_title) + '</div>' +
        (meta ? '<div class="pl-cart-item-meta">' + meta + '</div>' : '') +
        (pct > 0 ? '<div class="pl-cart-item-savings">Save ' + moneyShort(savings) + ' · ' + pct + '% off</div>' : '') +
        (item.requires_shipping === false
          ? ''   /* add-ons that don't ship (shipping protection): one per order, no +/- */
          : '<div class="pl-cart-qty">' +
              '<button type="button" data-cart-action="minus" data-line="' + (index + 1) +
                '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-cart-action="plus" data-line="' + (index + 1) +
                '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '</div>') +
        '<button type="button" class="pl-cart-remove" data-cart-action="remove" data-line="' +
          (index + 1) + '" aria-label="Remove">' +
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">' +
          '<path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg></button>' +
      '</div>' +
      '<div class="pl-cart-price-wrap">' +
        (savings > 0
          ? '<div class="pl-cart-regular-price">' + money(item.original_line_price) + '</div>'
          : '') +
        '<div class="pl-cart-price">' + money(item.final_line_price) + '</div>' +
      '</div>';

    cartItems.appendChild(itemEl);
  });

  /* ---------- totals (straight from Shopify, so they match checkout) ---------- */
  var total = cart.total_price;
  var original = total + totalSavings;

  if (cartTotal) cartTotal.textContent = money(total);
  if (checkoutTotal) checkoutTotal.textContent = money(total);
  if (cartCompare) {
    cartCompare.textContent = totalSavings > 0 ? money(original) : '';
    cartCompare.hidden = totalSavings <= 0;
  }

  /* ---------- savings card ---------- */
  if (savingsCard) savingsCard.hidden = true; /* savings now shown on the item itself */


  /* ---------- "add another jar" suggestion (inside the items list so the
     existing quantity buttons handler picks up the click) ---------- */
  {
    var q = creamLine ? creamLine.quantity : 0;
    if (q === 1 || q === 2) {
      var upgradeBox = document.createElement('div');
      upgradeBox.className = 'pl-cart-upgrade';
      var next = q + 1;
      var extra = TIER_TOTALS[next] - TIER_TOTALS[q];
      var saveNext = next * TIER_TOTALS[1] - TIER_TOTALS[next];
      upgradeBox.innerHTML =
        '<div class="pl-upgrade-copy">' +
          '<strong>Upgrade to a ' + SUPPLY_LABELS[next] + '</strong>' +
          '<span>Add 1 more jar for ' + moneyShort(extra) + ' · Save ' + moneyShort(saveNext) + '</span>' +
        '</div>' +
        '<button type="button" class="pl-upgrade-btn" data-cart-action="plus" data-line="' +
          (creamIndex + 1) + '" data-qty="' + q + '">Upgrade</button>';
      cartItems.appendChild(upgradeBox);
    }
  }

  /* ---------- add-ons (hide ones already in the bag) ---------- */
  if (upsellBox) {
    var visible = 0;
    upsellBox.querySelectorAll('[data-upsell-variant]').forEach(function (el) {
      var show = !inCart[Number(el.dataset.upsellVariant)];
      el.hidden = !show;
      if (show) visible++;
    });
    upsellBox.hidden = !hasItems || visible === 0;
  }

  /* ---------- shipping protection switch ---------- */
  if (cartCount) {
    cartCount.textContent = shippable;
    cartCount.dataset.count = shippable;
  }
  if (cartEmpty) cartEmpty.hidden = shippable > 0;
  if (protectToggle) {
    protectToggle.hidden = shippable === 0;
    protectToggle.querySelector('input').checked = !!inCart[PROTECT_ID];
    syncProtection(shippable, !!inCart[PROTECT_ID]);
  }

  /* ---------- free shipping bar ---------- */
  var remaining = FREE_SHIPPING_ALL ? 0 : Math.max(0, FREE_SHIPPING_THRESHOLD - total);
  var percent = FREE_SHIPPING_ALL
    ? 100
    : (hasItems ? Math.min(100, (total / FREE_SHIPPING_THRESHOLD) * 100) : 0);

  /* free on every order: the bar tracks jars instead —
     1 jar = free shipping, 2 jars = save $14, 3 jars = best price */
  var jars = creamLine ? creamLine.quantity : 0;
  var tracker = document.querySelector('.pl-cart-tracker');
  if (tracker) tracker.classList.toggle('pl-cart-tracker--jars', FREE_SHIPPING_ALL);
  if (FREE_SHIPPING_ALL) percent = hasItems ? Math.max(8, Math.min(100, (jars / 3) * 100)) : 0;

  if (shippingProgress) shippingProgress.style.width = percent + '%';

  if (shippingText) {
    if (FREE_SHIPPING_ALL) {
      if (jars >= 3) {
        shippingText.innerHTML = '<b>Free shipping + best price unlocked</b>';
      } else if (jars >= 1) {
        var nextSave = (jars + 1) * TIER_TOTALS[1] - TIER_TOTALS[jars + 1];
        shippingText.innerHTML = '<b>Free shipping unlocked</b> · add 1 jar to save ' + moneyShort(nextSave);
      } else {
        shippingText.innerHTML = '<b>Free shipping on every order</b>';
      }
    } else if (!hasItems) {
      shippingText.textContent = 'Free shipping on orders over ' + moneyShort(FREE_SHIPPING_THRESHOLD);
    } else if (remaining > 0) {
      shippingText.innerHTML = 'You\'re <b>' + money(remaining) + '</b> away from free shipping';

      /* If the optional shipping protection add-on would unlock free shipping,
         offer it right here as a one-tap link (the customer chooses). */
      var protectEl = document.querySelector('.pl-upsell-protect');
      if (protectEl && !inCart[Number(protectEl.dataset.upsellVariant)]) {
        var protectPrice = Number(protectEl.dataset.protectPrice) || 0;
        if (protectPrice >= remaining) {
          shippingText.innerHTML +=
            ' · <button type="button" class="pl-ship-nudge" data-ship-nudge>Add ' +
            escapeHtml(protectEl.dataset.protectTitle || 'Shipping Protection') +
            ' (' + money(protectPrice) + ') to unlock it</button>';
        }
      }
    } else {
      shippingText.innerHTML = '<b>You\'ve unlocked free shipping</b>';
    }
  }
}

/* one-tap "add shipping protection" link in the free-shipping message */
if (shippingText) {
  shippingText.addEventListener('click', function (event) {
    if (!event.target.closest('[data-ship-nudge]')) return;
    var addBtn = document.querySelector('.pl-upsell-protect .pl-upsell-add');
    if (addBtn) addBtn.click();
  });
}

/* Shipping protection is added automatically. If the customer switches it
   off we remember that for this visit and don't add it back. */
var protectBusy = false;
function protectOptedOut() {
  try { return sessionStorage.getItem('pl-protect-off') === '1'; } catch (e) { return false; }
}
function setProtectOptOut(off) {
  try { off ? sessionStorage.setItem('pl-protect-off', '1') : sessionStorage.removeItem('pl-protect-off'); } catch (e) {}
}
async function setProtection(on) {
  var toggle = document.querySelector('.pl-protect-toggle');
  if (!toggle || protectBusy) return;
  protectBusy = true;
  var id = Number(toggle.dataset.protectVariant);
  try {
    var res = on
      ? await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        })
      : await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(id), quantity: 0 })
        });
    if (!res.ok) throw new Error('Unable to update shipping protection.');
  } catch (error) {
    console.error(error);
  }
  protectBusy = false;
  refreshCart(false);
}
function syncProtection(shippable, hasProtection) {
  if (protectBusy) return;
  if (shippable > 0 && !hasProtection && !protectOptedOut()) {
    setProtection(true);          /* auto-add */
  } else if (shippable === 0 && hasProtection) {
    setProtection(false);         /* bag emptied: don't leave protection on its own */
  }
}
document.addEventListener('change', function (event) {
  var input = event.target.closest('.pl-protect-toggle input');
  if (!input) return;
  setProtectOptOut(!input.checked);
  setProtection(input.checked);
});

async function refreshCart(openAfter) {
  try {
    var cart = await getCart();
    renderCart(cart);
    if (openAfter) {
      openCartDrawer();
    }
  } catch (error) {
    console.error('Cart error:', error);
  }
}


// ==========================================================
// ADD TO CART
// ==========================================================

document.querySelectorAll('[data-variant]').forEach(function (btn) {

  btn.addEventListener('click', async function () {

    var id =
      btn.dataset.variant ||
      PRODUCT_VARIANT_ID;

    var qty =
      parseInt(btn.dataset.qty || '1', 10);

    if (!id) {
      alert('This product has not been connected to a Shopify variant.');
      return;
    }

    var originalLabel = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    try {

      var response = await fetch('/cart/add.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          items: [
            {
              id: Number(id),
              quantity: qty
            }
          ]
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add this product.'
        );
      }

      await refreshCart(true);

    } catch (error) {

      console.error(error);

      alert(
        error.message ||
        'There was a problem adding this item to your bag.'
      );

    } finally {

      btn.disabled = false;
      btn.textContent = originalLabel;

    }

  });

});


// ==========================================================
// CART QUANTITY CONTROLS
// ==========================================================

if (cartItems) {

  cartItems.addEventListener('click', async function (event) {

    var button =
      event.target.closest('[data-cart-action]');

    if (!button) return;

    var action =
      button.dataset.cartAction;

    var line =
      Number(button.dataset.line);

    var currentQty =
      Number(button.dataset.qty || 0);

    var newQty = currentQty;

    if (action === 'plus') {
      newQty = currentQty + 1;
    }

    if (action === 'minus') {
      newQty = Math.max(0, currentQty - 1);
    }

    if (action === 'remove') {
      newQty = 0;
    }

    try {

      button.disabled = true;

      var response = await fetch('/cart/change.js', {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },

        body: JSON.stringify({
          line: line,
          quantity: newQty
        })
      });

      var cart = await response.json();

      if (!response.ok) {
        throw new Error(
          cart.description ||
          'Unable to update cart.'
        );
      }

      renderCart(cart);

    } catch (error) {

      console.error(error);

      alert(
        error.message ||
        'Unable to update your bag.'
      );

    }

  });

}


// ==========================================================
// OPEN / CLOSE CART
// ==========================================================

if (cartBag) {
  cartBag.addEventListener('click', function () {
    refreshCart(true);
  });
}

if (cartClose) {
  cartClose.addEventListener('click', closeCartDrawer);
}

if (cartOverlay) {
  cartOverlay.addEventListener('click', closeCartDrawer);
}

if (continueShopping) {
  continueShopping.addEventListener('click', closeCartDrawer);
}

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeCartDrawer();
  }
});


// ==========================================================
// CHECKOUT
// ==========================================================

if (checkoutButton) {

  checkoutButton.addEventListener('click', function () {
    window.location.href = '/checkout';
  });

}


// Load current cart quantity on page load
refreshCart(false);
// ==========================================================
// PURE LEAF EMAIL POPUP
// ==========================================================

var plPopup = document.getElementById('pl-email-popup');
var plPopupClose = document.querySelector('.pl-popup-close');
var plPopupBackdrop = document.querySelector('.pl-popup-backdrop');

var PL_POPUP_STORAGE_KEY = 'pure_leaf_popup_seen';
var PL_POPUP_DELAY =
  (Number(plPopup && plPopup.dataset.delay) || 3) * 1000;
var PL_POPUP_COOLDOWN = 7 * 24 * 60 * 60 * 1000;


function plOpenPopup() {

  if (!plPopup) return;

  plPopup.classList.add('is-open');

  plPopup.setAttribute(
    'aria-hidden',
    'false'
  );

  document.body.style.overflow = 'hidden';

}


function plClosePopup() {

  if (!plPopup) return;

  plPopup.classList.remove('is-open');

  plPopup.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.style.overflow = '';

  try {

    localStorage.setItem(
      PL_POPUP_STORAGE_KEY,
      Date.now().toString()
    );

  } catch (e) {}

}


function plShouldShowPopup() {

  try {

    var seen =
      localStorage.getItem(
        PL_POPUP_STORAGE_KEY
      );

    if (!seen) {
      return true;
    }

    var elapsed =
      Date.now() - Number(seen);

    return elapsed >
      PL_POPUP_COOLDOWN;

  } catch (e) {

    return true;

  }

}


if (plPopup) {

  /*
   * Show after the delay set in the theme editor (default 3 seconds).
   * The popup will not appear again for 7 days
   * after the visitor closes it.
   */

  if (plPopup.querySelector('[data-popup-success]')) {

    /* The visitor just signed up. If they used the popup form,
       reopen it right away so they see their discount code.
       Either way, don't ask them to sign up again for 7 days. */
    try {
      localStorage.setItem(PL_POPUP_STORAGE_KEY, Date.now().toString());
    } catch (e) {}

    if (window.location.hash === '#pl-popup-form') {

      /* Shopify reloads the page with "#pl-popup-form" in the address.
         The browser then scrolls the popup's contents to that form, which
         pushes the top of the popup (and the close button) out of view.
         Remove the hash and put everything back to the top. */
      try {
        history.replaceState(
          null, '', window.location.pathname + window.location.search
        );
      } catch (e) {}

      var plResetPopupScroll = function () {
        plPopup.scrollTop = 0;
        plPopup.querySelectorAll('*').forEach(function (el) {
          if (el.scrollTop) el.scrollTop = 0;
        });
        window.scrollTo(0, 0);
      };

      plOpenPopup();
      plResetPopupScroll();
      window.addEventListener('load', plResetPopupScroll);
      window.setTimeout(plResetPopupScroll, 150);
      window.setTimeout(plResetPopupScroll, 600);
    }

  } else if (plShouldShowPopup()) {

    window.setTimeout(function () {

      plOpenPopup();

    }, PL_POPUP_DELAY);

  }


  if (plPopupClose) {

    plPopupClose.addEventListener(
      'click',
      plClosePopup
    );

  }


  if (plPopupBackdrop) {

    plPopupBackdrop.addEventListener(
      'click',
      plClosePopup
    );

  }


  document.addEventListener(
    'keydown',
    function (event) {

      if (event.key === 'Escape') {

        plClosePopup();

      }

    }
  );


  /*
   * After successful Shopify newsletter submission,
   * leave the success message visible.
   */

  var popupForm =
    document.getElementById(
      'pl-popup-form'
    );

  if (
    popupForm &&
    popupForm.querySelector(
      '.errors'
    )
  ) {

    plOpenPopup();

  }

}

/* ==========================================================
   PURE LEAF SEAMLESS REVIEW CAROUSEL
   ========================================================== */

/* ==========================================================
   PURE LEAF TRUE INFINITE REVIEW CAROUSEL
   ========================================================== */

var reviewCarousel =
  document.getElementById('plReviewCarousel');

var reviewPrev =
  document.querySelector('.pl-review-prev');

var reviewNext =
  document.querySelector('.pl-review-next');

var reviewDots =
  document.querySelector('.pl-review-dots');


if (reviewCarousel) {

  var originalCards =
    Array.from(
      reviewCarousel.querySelectorAll('.pl-review-card')
    );

  if (originalCards.length > 1) {

    var reviewAutoRotate;
    var REVIEW_ROTATE_DELAY = 5000;

    var totalReviews =
      originalCards.length;

    var isResetting = false;


    /* ==========================================================
       CLONE ALL REVIEWS ON BOTH SIDES
       ========================================================== */

    var beforeFragment =
      document.createDocumentFragment();

    var afterFragment =
      document.createDocumentFragment();


    originalCards.forEach(
      function (card) {

        var beforeClone =
          card.cloneNode(true);

        beforeClone.classList.add(
          'pl-review-clone'
        );

        beforeFragment.appendChild(
          beforeClone
        );


        var afterClone =
          card.cloneNode(true);

        afterClone.classList.add(
          'pl-review-clone'
        );

        afterFragment.appendChild(
          afterClone
        );

      }
    );


    reviewCarousel.insertBefore(
      beforeFragment,
      originalCards[0]
    );

    reviewCarousel.appendChild(
      afterFragment
    );


    /* ==========================================================
       CARD SIZE / POSITION
       ========================================================== */

    function getCardGap() {

      var style =
        window.getComputedStyle(
          reviewCarousel
        );

      return (
        parseFloat(
          style.columnGap ||
          style.gap ||
          0
        ) || 0
      );

    }


    function getStep() {

      var card =
        reviewCarousel.querySelector(
          '.pl-review-card'
        );

      if (!card) return 0;

      return (
        card.getBoundingClientRect().width +
        getCardGap()
      );

    }


    function getCurrentIndex() {

      var step =
        getStep();

      if (!step) {
        return totalReviews;
      }

      return Math.round(
        reviewCarousel.scrollLeft /
        step
      );

    }


    function scrollToIndex(
      index,
      smooth
    ) {

      var step =
        getStep();

      if (!step) return;

      reviewCarousel.scrollTo({
        left: index * step,

        behavior:
          smooth
            ? 'smooth'
            : 'auto'
      });

    }


    /* ==========================================================
       START ON FIRST REAL REVIEW
       ========================================================== */

    requestAnimationFrame(
      function () {

        scrollToIndex(
          totalReviews,
          false
        );

      }
    );


    /* ==========================================================
       NEXT / PREVIOUS
       ========================================================== */

    function moveNext() {

      if (isResetting) return;

      var index =
        getCurrentIndex();

      scrollToIndex(
        index + 1,
        true
      );

    }


    function movePrev() {

      if (isResetting) return;

      var index =
        getCurrentIndex();

      scrollToIndex(
        index - 1,
        true
      );

    }


    /* ==========================================================
       INVISIBLE LOOP RESET
       ========================================================== */

    var reviewScrollTimer;


    reviewCarousel.addEventListener(
      'scroll',
      function () {

        clearTimeout(
          reviewScrollTimer
        );


        reviewScrollTimer =
          setTimeout(
            function () {

              var index =
                getCurrentIndex();


              /*
               * We have:
               *
               * 0 ... N-1
               * LEFT CLONES
               *
               * N ... 2N-1
               * REAL REVIEWS
               *
               * 2N ... 3N-1
               * RIGHT CLONES
               */


              /* Entered right-side clones */

              if (
                index >=
                totalReviews * 2
              ) {

                isResetting = true;


                var equivalentIndex =
                  index - totalReviews;


                scrollToIndex(
                  equivalentIndex,
                  false
                );


                requestAnimationFrame(
                  function () {

                    isResetting = false;

                  }
                );

              }


              /* Entered left-side clones */

              else if (
                index <
                totalReviews
              ) {

                isResetting = true;


                var equivalentIndex =
                  index + totalReviews;


                scrollToIndex(
                  equivalentIndex,
                  false
                );


                requestAnimationFrame(
                  function () {

                    isResetting = false;

                  }
                );

              }


              updateDots();

            },
            120
          );

      },
      { passive: true }
    );


    /* ==========================================================
       ARROWS
       ========================================================== */

    if (reviewNext) {

      reviewNext.addEventListener(
        'click',
        function () {

          stopReviewAutoRotate();

          moveNext();

          startReviewAutoRotate();

        }
      );

    }


    if (reviewPrev) {

      reviewPrev.addEventListener(
        'click',
        function () {

          stopReviewAutoRotate();

          movePrev();

          startReviewAutoRotate();

        }
      );

    }


    /* ==========================================================
       DOTS
       ========================================================== */

    function getRealIndex() {

      var index =
        getCurrentIndex();

      var realIndex =
        (
          index -
          totalReviews
        ) %
        totalReviews;


      if (realIndex < 0) {

        realIndex +=
          totalReviews;

      }


      return realIndex;

    }


    function updateDots() {

      if (!reviewDots) return;


      var activeIndex =
        getRealIndex();


      reviewDots
        .querySelectorAll(
          '.pl-review-dot'
        )
        .forEach(
          function (
            dot,
            index
          ) {

            dot.classList.toggle(
              'active',
              index === activeIndex
            );

          }
        );

    }


    if (reviewDots) {

      reviewDots.innerHTML = '';


      originalCards.forEach(
        function (
          _,
          index
        ) {

          var dot =
            document.createElement(
              'button'
            );


          dot.type =
            'button';


          dot.className =
            'pl-review-dot' +
            (
              index === 0
                ? ' active'
                : ''
            );


          dot.setAttribute(
            'aria-label',
            'Go to review ' +
            (index + 1)
          );


          dot.addEventListener(
            'click',
            function () {

              stopReviewAutoRotate();


              scrollToIndex(
                totalReviews +
                index,
                true
              );


              startReviewAutoRotate();

            }
          );


          reviewDots.appendChild(
            dot
          );

        }
      );

    }


    /* ==========================================================
       AUTO ROTATE
       ========================================================== */

    function startReviewAutoRotate() {

      clearInterval(
        reviewAutoRotate
      );


      reviewAutoRotate =
        setInterval(
          moveNext,
          REVIEW_ROTATE_DELAY
        );

    }


    function stopReviewAutoRotate() {

      clearInterval(
        reviewAutoRotate
      );

    }


    startReviewAutoRotate();


    /* ==========================================================
       PAUSE ON CUSTOMER INTERACTION
       ========================================================== */

    reviewCarousel.addEventListener(
      'mouseenter',
      stopReviewAutoRotate
    );


    reviewCarousel.addEventListener(
      'mouseleave',
      startReviewAutoRotate
    );


    reviewCarousel.addEventListener(
      'pointerdown',
      stopReviewAutoRotate
    );


    reviewCarousel.addEventListener(
      'pointerup',
      startReviewAutoRotate
    );


    reviewCarousel.addEventListener(
      'touchstart',
      stopReviewAutoRotate,
      {
        passive: true
      }
    );


    reviewCarousel.addEventListener(
      'touchend',
      startReviewAutoRotate,
      {
        passive: true
      }
    );


    /* ==========================================================
       PAUSE WHEN TAB IS HIDDEN
       ========================================================== */

    document.addEventListener(
      'visibilitychange',
      function () {

        if (document.hidden) {

          stopReviewAutoRotate();

        } else {

          startReviewAutoRotate();

        }

      }
    );


    /* ==========================================================
       MAINTAIN POSITION AFTER RESIZE
       ========================================================== */

    window.addEventListener(
      'resize',
      function () {

        var realIndex =
          getRealIndex();


        scrollToIndex(
          totalReviews +
          realIndex,
          false
        );

      }
    );

  
  }

}

});
